'use strict';

var constants = require('../constants.cjs');

const sortDayOfWeeks = (dayOfWeeks) => [...dayOfWeeks].sort(
  (a, b) => constants.DAY_OF_WEEKS.indexOf(a) - constants.DAY_OF_WEEKS.indexOf(b)
);

module.exports = sortDayOfWeeks;
//# sourceMappingURL=sortDayOfWeeks.cjs.map
